import {css} from '@emotion/css';
import {CustomerItem, DEFAULT_MARKET, getMarketFormalAddress, Timestamp} from '@remoov/functional';
import {theme} from '@remoov/remoov-components';
import React from 'react';
import {
  ItemsBoardContainer,
  ItemsBoardHeader,
  ItemsBoardLeftContainer,
  ItemsBoardRightContainer,
  ItemsBoardRow,
  ItemsBoardRowWithActionIcon,
  ItemsBoardTitle,
} from '../Common';
import {ExpiredBoardItem} from '../ExpiredBoardItem';
import {ItemDetailsModal} from '../ItemDetailsModal';
import {ItemReturnModal} from '../ItemReturnModal';
import downArrow from './downarrow.svg';
import upArrow from './uparrow.svg';

export type ReturnModal = {
  item: Maybe<CustomerItem>;
  date: Timestamp;
};

export type ExpiredBoardProps = {
  items: CustomerItem[];
  isOpenModal: Maybe<number>;
  setIsOpenModal: (itemId: Maybe<number>) => unknown;
  donateAction: (value: CustomerItem) => unknown;
  sort: string;
  sortDirection: 'asc' | 'desc';
  setSort: (column: string) => unknown;
  returnModal: ReturnModal;
  setReturnModal: (newReturnModal: RecursivePartial<ReturnModal>) => unknown;
  submitReturnModal: () => unknown;
  notMyItem: (item: CustomerItem) => unknown;
  requestReturn: (item: CustomerItem) => unknown;
};

export const ExpiredBoard = ({
  items,
  isOpenModal,
  setIsOpenModal,
  donateAction,
  sort,
  sortDirection,
  setSort,
  returnModal,
  setReturnModal,
  submitReturnModal,
  notMyItem,
  requestReturn,
}: ExpiredBoardProps) => (
  <ItemsBoardContainer>
    <ItemsBoardHeader>
      <ItemsBoardLeftContainer
        className={css({marginLeft: '194px', padding: `${theme.spacings.xsmall} 0`})}
      >
        <ItemsBoardRowWithActionIcon
          className={css({maxWidth: '100px'})}
          onClick={() => setSort('barcode')}
        >
          <ItemsBoardTitle>ID</ItemsBoardTitle>
          {sort !== 'barcode' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('description')}>
          <ItemsBoardTitle>DESCRIPTION</ItemsBoardTitle>
          {sort !== 'description' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
      </ItemsBoardLeftContainer>
      <ItemsBoardRightContainer className={css({margin: `${theme.spacings.xsmall} 0`})}>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('quantity')}>
          <ItemsBoardTitle>QUANTITY</ItemsBoardTitle>
          {sort !== 'quantity' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('end_of_consignment')}>
          <ItemsBoardTitle>EXPIRED ON</ItemsBoardTitle>
          {sort !== 'end_of_consignment' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
        <ItemsBoardRow>
          <ItemsBoardTitle>ACTION</ItemsBoardTitle>
        </ItemsBoardRow>
      </ItemsBoardRightContainer>
    </ItemsBoardHeader>
    {items.map(item => (
      <>
        <ExpiredBoardItem
          item={item}
          alt={item.material || ''}
          imgUrl={item.big_url || ''}
          id={item.id || 0}
          description={item.description || ''}
          market={item.market || DEFAULT_MARKET}
          quantity={item.quantity || 0}
          expired={item.end_of_consignment || ''}
          onClick={() => setIsOpenModal(item.id)}
          donateAction={() => donateAction(item)}
          returnAction={() => setReturnModal({item})}
          actionSelected={item.end_of_consignment_action || null}
        />
        {isOpenModal === item.id && (
          <ItemDetailsModal
            isOpen={isOpenModal === item.id}
            setIsOpen={newIsOpen => (newIsOpen ? setIsOpenModal(item.id) : setIsOpenModal(null))}
            code={item.id || ''}
            imgUrl={item.big_url || ''}
            imgAlt={item.material || ''}
            category={item.item_category_id || ''}
            brand={item.brand || ''}
            original_price={item.original_price || ''}
            notMyItem={() => notMyItem(item)}
            requestReturn={item.status === 'For Sale' ? () => requestReturn(item) : null}
          />
        )}
        {returnModal?.item?.id === item.id && (
          <ItemReturnModal
            isOpen={returnModal?.item?.id === item.id}
            setIsOpen={newIsOpen =>
              newIsOpen ? setReturnModal({item}) : setReturnModal({item: null})
            }
            address={getMarketFormalAddress(item.market)}
            returnModal={returnModal}
            setReturnModal={setReturnModal}
            submitReturnModal={submitReturnModal}
          />
        )}
      </>
    ))}
  </ItemsBoardContainer>
);
